import React from 'react';
import { WardsData } from '../../Datas/WardsData';
import './DrugConModal.css';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; 

const DrugConModal = ({ onClose, wardName }) => {
  const ward = WardsData.find((w) => w.wardName === wardName);
  const drugConsumptionData = ward ? ward.DrugConsumption : [];

  const handleClose = () => {
    onClose();
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text(`Drug Consumption for ${wardName} Department`, 14, 20);

    const tableData = drugConsumptionData.map((patient) => {
      return patient.medications.map((medication) => [
        patient.patientId,
        patient.diagnosis,
        medication.medicationName,
        medication.prescribedQuantity,
        medication.consumedQuantity,
        medication.issueQuantity,
        medication.totalCost
      ]);
    }).flat();

    const columns = [
      'Patient ID', 'Diagnosis', 'Medication',
      'Prescribed Quantity', 'Consumed Quantity', 'Issue Quantity', 'Cost'
    ];

    doc.autoTable(columns, tableData, { startY: 30 });

    doc.save(`${wardName}_Drug_Consumption.pdf`);
  };

  return (
    <div className="drug-con-modal-overlay" onClick={handleClose}>
      <div className="drug-con-modal-container" onClick={(e) => e.stopPropagation()}>
        <h3 className="drug-con-modal-header">Drug Consumption for {wardName} Department</h3>
        <div className="drug-con-table-wrapper">
          <table className="drug-con-summary-table">
            <thead>
              <tr>
                <th>Bed Number</th>
                <th>Diagnosis</th>
                <th>Medication</th>
                <th>Prescribed Quantity</th>
                <th>Consumed Quantity</th>
                <th>Issue Quantity</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              {drugConsumptionData.map((patient) => (
                <>
                  {patient.medications.map((medication, index) => (
                    <tr key={index}>
                      {index === 0 && (
                        <>
                          <td rowSpan={patient.medications.length}>{patient.patientId}</td>
                          <td rowSpan={patient.medications.length}>{patient.diagnosis}</td>
                        </>
                      )}
                      <td>{medication.medicationName}</td>
                      <td>{medication.prescribedQuantity}</td>
                      <td>{medication.consumedQuantity}</td>
                      <td>{medication.issueQuantity}</td>
                      <td>{medication.totalCost}</td>
                    </tr>
                  ))}
                </>
              ))}
            </tbody>
          </table>
        </div>

        <button className="drug-con-download-btn" onClick={generatePDF}>
          Download as PDF
        </button>

        <button className="close-btn" onClick={handleClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default DrugConModal;
